import { PREWAGER_WALLET_ACCOUNT_ID } from '@namespace/helpers';

const getPreWagerBalance = (wallets = []) =>
  wallets.find(
    ({ walletAccountId }) => walletAccountId === PREWAGER_WALLET_ACCOUNT_ID
  );

export default getPreWagerBalance;
